const bufferButtons = Array.from(document.querySelectorAll('.j-button-buffer'));

const copyToClipboard = (textToCopy: string): void => {
    const tempInput = document.createElement('textarea');

    tempInput.value = textToCopy;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
};


if (bufferButtons) {
    bufferButtons.forEach((button: any) => {
        button.addEventListener('click', (event: MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();

            const tooltip = button.querySelector('.j-button-tooltip');

            copyToClipboard(window.location.href);

            tooltip.innerHTML = button.dataset['text'];
            tooltip.classList.add('is-active');
            setTimeout(() => {
                tooltip.classList.remove('is-active');
                tooltip.innerHTML = '';
            }, 2010);
        });
    });
}
